var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 9,
    fill: "#4B4AD5",
    stroke: "#4B4AD5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61433 11.2656C8.35763 11.0115 7.94352 11.0135 7.68938 11.2702C7.43524 11.5269 7.43732 11.941 7.69401 12.1952L11.0392 15.2995C11.3082 15.5658 11.7464 15.5489 11.994 15.2626L17.3406 9.08195C17.5769 8.80876 17.547 8.39573 17.2738 8.15941C17.0007 7.92308 16.5876 7.95297 16.3513 8.22616L11.4624 13.8777L8.61433 11.2656Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioOn);
export default __webpack_public_path__ + "static/media/radio-on.9fdef96d946617bb8f832ebf864d53d6.svg";
export { ForwardRef as ReactComponent };